export default {
	welcome: "Bem-vindo ao ORI",
	subtitle: "Escolha como deseja começar",
	registerTemple: "Cadastrar meu Templo",
	registerTempleDesc: "Sou líder ou administrador de um templo e quero cadastrá-lo no sistema",
	joinAsMember: "Entrar como Membro",
	joinAsMemberDesc: "Fui convidado por um templo para fazer parte da equipe",
	viewPlans: "Ver planos e preços",
	viewPlansDesc: "Monte seu plano — base mais os adicionais que quiser — e veja o valor",
	alreadyHaveAccount: "Já tem uma conta?",
	login: "Fazer login",
	termsOfUse: "Termos de Uso",
	privacyPolicy: "Política de Privacidade",
	acceptTermsPrefix: "Li e concordo com os",
	acceptTermsMiddle: "e a",
	termsRequired: "Você deve aceitar os termos para continuar",
};
